import { z } from "zod";
import { ENTITY_TYPES } from "../../constants.js";
import { formatZodError } from "../../utils.js";

type TypeSchemaRecord = Partial<Record<ENTITY_TYPES, z.ZodTypeAny>>;
export const validateIncluded = <T>({
    datas,
    typeSchemaRecord,
    ctx,
    preventError,
}: {
    datas: Array<unknown>;
    typeSchemaRecord: TypeSchemaRecord;
    ctx: z.RefinementCtx;
    preventError?: true;
}): Array<T> => {
    return datas.filter((data) => {
        if (data === null || typeof data !== "object" || !("$type" in data) || typeof data.$type !== "string") return false;
        const entries = Object.entries(typeSchemaRecord);
        for (const [key, value] of entries) {
            if (data.$type === key) {
                const validation = value.safeParse(data);
                if (!validation.success) {
                    if (!preventError)
                        ctx.addIssue({
                            code: z.ZodIssueCode.custom,
                            message: formatZodError(validation.error),
                        });
                    return false;
                }
                return true;
            }
        }
        return false;
    }) as Array<T>;
};
